'use client';

import type { ReactNode } from 'react';
import JssRegistryProvider from './JssRegistryProvider';
import PulseProviderWrapper from './PulseProviderWrapper';
import { MiniappDeploymentProvider } from '@/miniapp/DeploymentProvider';

type Props = {
  children: ReactNode;
  /** Server-resolved; see `MiniappDeploymentProvider`. */
  miniappDeploymentUrl: string | null;
};

const Providers = ({ children, miniappDeploymentUrl }: Props) => {
  return (
    <PulseProviderWrapper>
      <MiniappDeploymentProvider deploymentUrl={miniappDeploymentUrl}>
        <JssRegistryProvider>{children}</JssRegistryProvider>
      </MiniappDeploymentProvider>
    </PulseProviderWrapper>
  );
};

export default Providers;
